import Hero from "@/sections/Hero";
import CommunityPulse from "@/sections/CommunityPulse";
import JobsBoard from "@/sections/JobsBoard";
import AcademyFeature from "@/sections/AcademyFeature";
import FeaturedIn from "@/sections/FeaturedIn";
import MarketBoard from "@/components/MarketBoard";
import InTheNews from "@/sections/InTheNews";
import Mission from "@/sections/Mission";
import WireHighlight from "@/sections/WireHighlight";
import WhyNow from "@/sections/WhyNow";
import CertifiedPartner from "@/sections/CertifiedPartner";
import Partnership from "@/sections/Partnership";
import Founder from "@/sections/Founder";
import Events from "@/sections/Events";
import GetInvolvedCta from "@/sections/GetInvolvedCta";
import BookMeeting from "@/sections/BookMeeting";
import { CareersHubPreview } from "@/components/landing/CareersHubPreview";
import { ExploreGrid } from "@/components/landing/ExploreGrid";
import { DataCenterExplainer } from "@/components/landing/DataCenterExplainer";

const EngageSection = () => (
  <section id="engage" data-testid="engage-section" className="border-t hairline">
    <div className="grid lg:grid-cols-2">
      <GetInvolvedCta />
      <BookMeeting />
    </div>
  </section>
);

export const LandingCurrent = () => (
  <>
    <Hero />
    <FeaturedIn />
    <DataCenterExplainer />
    <Mission />
    <CommunityPulse />
    <JobsBoard />
    <WhyNow />
    <Founder />
    <WireHighlight />
    <InTheNews />
    <CertifiedPartner />
    <Partnership />
    <Events />
    <EngageSection />
    <MarketBoard />
  </>
);

export const LandingHybrid = () => (
  <>
    <Hero />
    <FeaturedIn />
    <ExploreGrid />
    <CareersHubPreview />
    <JobsBoard />
    <Events />
    <EngageSection />
    <Mission />
    <CommunityPulse />
    <AcademyFeature />
    <WhyNow />
    <Founder />
    <WireHighlight />
    <InTheNews />
    <CertifiedPartner />
    <Partnership />
    <MarketBoard />
  </>
);

export const LandingCareersFirst = () => (
  <>
    <Hero />
    <JobsBoard />
    <CareersHubPreview />
    <CommunityPulse />
    <Events />
    <EngageSection />
  </>
);

export const LandingStoryFirst = () => (
  <>
    <Hero />
    <Mission />
    <FeaturedIn />
    <CommunityPulse />
    <Events />
    <EngageSection />
  </>
);

export const LandingCompact = () => (
  <>
    <Hero />
    <FeaturedIn />
    <ExploreGrid />
    <EngageSection />
  </>
);
